var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React from 'react';
import { useGridDropdown } from '../hooks/useGridDropdown';
import { DataGridDropdownEllipsis } from './DataGridDropdownEllipsis';
import './CellWithGridDropdown.scss';
export const CellWithGridDropdown = (_a) => {
    var { gridDropdownProps } = _a, props = __rest(_a, ["gridDropdownProps"]);
    const { value, children, fullWidth } = props;
    const { showCellDropdown, userHoverCell, userLeavesCell, handleOptionSelection, } = useGridDropdown(value, gridDropdownProps);
    return (React.createElement("div", { className: classnames('cell-with-dropdown', { 'w-100': fullWidth }), onMouseEnter: userHoverCell, onMouseLeave: userLeavesCell },
        children,
        showCellDropdown && (React.createElement(DataGridDropdownEllipsis, { handleOptionSelection: handleOptionSelection, options: gridDropdownProps.options }))));
};
//# sourceMappingURL=CellWithGridDropdown.js.map